import { BaseModMod } from '../models/mods/base-mod-mod.model';
import { RequestQueryBuilder, SCondition } from '@nestjsx/crud-request';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import {Injectable} from '@angular/core';
import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {Burly} from 'kb-burly';
import {ManyResponse} from '../../../responses/many.response';

@Injectable({
  providedIn: 'root'
})
export class TorchModModService {

  constructor(protected config: TorchAPIConfiguration,
              private httpClient: HttpClient) {
  }

  public queryMods(pageSize: number = 15,
                   currentPage: number = 0,
                   sortDirection: 'ASC' | 'DESC' | '' = 'DESC',
                   sortBy: string = 'MOD_MOD_ISN',
                   filters: SCondition | null): Observable<ManyResponse<BaseModMod>> {
    const qb = RequestQueryBuilder.create();

    qb.setPage(currentPage + 1).setLimit(pageSize);

    if (!!sortDirection && sortDirection != null) {
      qb.sortBy({field: sortBy, order: sortDirection});
    }

    if (!!filters) {
      qb.search(filters);
    }

    let finalURL;
    const endpoint = Burly(this.config.rootUrl)
    .addSegment('/mods/mod')
    .appendRawQueryString(qb.query(false));

    finalURL = endpoint.get;

    return this.httpClient.get<ManyResponse<BaseModMod>>(finalURL);
  }

  public getModTypes(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/mods/mod')
      .addSegment('/modTypes')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ NAME: string }]>(endpoint).pipe(
      map(response => response.map(v => v.NAME))
    );
  }

  public getATAChapters(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/mods/mod')
      .addSegment('/ataChapters')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ ATA_CHAPTER: string }]>(endpoint).pipe(
      map(response => response.map(v => v.ATA_CHAPTER))
    );
  }

  public getATAs(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/mods/mod')
      .addSegment('/atas')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ ATA: string }]>(endpoint).pipe(
      map(response => response.map(v => v.ATA))
    );
  }

  public getAdaptReleaseBy(contains): Observable<string[]> {
    const endpoint = Burly(this.config.rootUrl)
      .addSegment('/mods/mod')
      .addSegment('/adaptReleaseBy')
      .addQuery('contains', contains)
      .get;

    return this.httpClient.get<[{ ADAPT_RELEASE_BY: string }]>(endpoint).pipe(
      map(response => response.map(v => v.ADAPT_RELEASE_BY))
    );
  }
}
